export default {
	"cattle": {
		"names": [
			"British (e.g. Angus, Hereford)",
			"European (e.g. Simmental)",
			"Bos indicus (e.g. Brahman)",
			"British x European",
			"British x B. indicus"
		] as const,
		"classes": {
			"breeding": [
				"Cows (>3 years)",
				"Cows (2-3 years)",
				"Heifers (1-2 years)",
				"Steers (1-2 years)",
				"Weaned young heifers",
				"Weaned young steers",
				"Calves weaned this year"
			] as const,
			"trading": [
				"Dry cows or heifers",
				"Steers",
				"Bulls",
				"Weaned young heifers",
				"Weaned young steers"
			] as const
		}
	},
	"sheep": {
		"names": [
			"Merino or similar breed",
			"Meat sheep (e.g. Poll Dorset)"
		] as const,
		"classes": {
			"breeding": [
				"Ewes (>2 years)",
				"Ewes (1-2 years)",
				"Wethers (1-2 years)",
				"Weaned young ewes",
				"Weaned young wethers",
				"Lambs weaned this year"
			] as const,
			"trading": [
				"Dry ewes",
				"Wethers",
				"Rams",
				"Weaned young ewes",
				"Weaned young wethers"
			] as const
		}
	},
	"parameters": {
		"Twins:a": {
			"British(e.g.Angus,Hereford)": 0,
			"European(e.g.Simmental)": 0,
			"Bosindicus(e.g.Brahman)": 0,
			"BritishxEuropean": 0,
			"BritishxB.indicus": 0,
			"Merinoorsimilarbreed": -0.15,
			"Meatsheep(e.g.PollDorset)": -0.12
		},
		"Twins:b": {
			"British(e.g.Angus,Hereford)": 0,
			"European(e.g.Simmental)": 0,
			"Bosindicus(e.g.Brahman)": 0,
			"BritishxEuropean": 0,
			"BritishxB.indicus": 0,
			"Merinoorsimilarbreed": 0.96,
			"Meatsheep(e.g.PollDorset)": 1.28
		},
		"DLF(1)": {
			"British(e.g.Angus,Hereford)": 0,
			"European(e.g.Simmental)": 0,
			"Bosindicus(e.g.Brahman)": 0,
			"BritishxEuropean": 0,
			"BritishxB.indicus": 0,
			"Merinoorsimilarbreed": 0.23,
			"Meatsheep(e.g.PollDorset)": 0.34
		},
		"DLF(2)": {
			"British(e.g.Angus,Hereford)": 0,
			"European(e.g.Simmental)": 0,
			"Bosindicus(e.g.Brahman)": 0,
			"BritishxEuropean": 0,
			"BritishxB.indicus": 0,
			"Merinoorsimilarbreed": 0.39,
			"Meatsheep(e.g.PollDorset)": 0.64
		},
		"BW:N": {
			"British(e.g.Angus,Hereford)": 0.07,
			"European(e.g.Simmental)": 0.07,
			"Bosindicus(e.g.Brahman)": 0.07,
			"BritishxEuropean": 0.07,
			"BritishxB.indicus": 0.07,
			"Merinoorsimilarbreed": 0.1,
			"Meatsheep(e.g.PollDorset)": 0.1
		},
		"C(N,1)": {
			"British(e.g.Angus,Hereford)": 0.0115,
			"European(e.g.Simmental)": 0.0115,
			"Bosindicus(e.g.Brahman)": 0.0115,
			"BritishxEuropean": 0.0115,
			"BritishxB.indicus": 0.0115,
			"Merinoorsimilarbreed": 0.0157,
			"Meatsheep(e.g.PollDorset)": 0.0157
		},
		"C(M,2)": {
			"British(e.g.Angus,Hereford)": 0.36,
			"European(e.g.Simmental)": 0.36,
			"Bosindicus(e.g.Brahman)": 0.31,
			"BritishxEuropean": 0.36,
			"BritishxB.indicus": 0.335,
			"Merinoorsimilarbreed": 0.26,
			"Meatsheep(e.g.PollDorset)": 0.26
		},
		"C(M,6)": {
			"British(e.g.Angus,Hereford)": 0.0025,
			"European(e.g.Simmental)": 0.0025,
			"Bosindicus(e.g.Brahman)": 0.0025,
			"BritishxEuropean": 0.0025,
			"BritishxB.indicus": 0.0025,
			"Merinoorsimilarbreed": 0.02,
			"Meatsheep(e.g.PollDorset)": 0.02
		},
		"C(P,1)": {
			"British(e.g.Angus,Hereford)": 285,
			"European(e.g.Simmental)": 285,
			"Bosindicus(e.g.Brahman)": 285,
			"BritishxEuropean": 285,
			"BritishxB.indicus": 285,
			"Merinoorsimilarbreed": 150,
			"Meatsheep(e.g.PollDorset)": 150
		},
		"C(P,2)": {
			"British(e.g.Angus,Hereford)": 2.2,
			"European(e.g.Simmental)": 2.2,
			"Bosindicus(e.g.Brahman)": 2.2,
			"BritishxEuropean": 2.2,
			"BritishxB.indicus": 2.2,
			"Merinoorsimilarbreed": 1.304,
			"Meatsheep(e.g.PollDorset)": 1.304
		},
		"C(P,3)": {
			"British(e.g.Angus,Hereford)": 1.77,
			"European(e.g.Simmental)": 1.77,
			"Bosindicus(e.g.Brahman)": 1.77,
			"BritishxEuropean": 1.77,
			"BritishxB.indicus": 1.77,
			"Merinoorsimilarbreed": 2.625,
			"Meatsheep(e.g.PollDorset)": 2.625
		},
		"C(P,5)": {
			"British(e.g.Angus,Hereford)": 1.8,
			"European(e.g.Simmental)": 1.8,
			"Bosindicus(e.g.Brahman)": 1.8,
			"BritishxEuropean": 1.8,
			"BritishxB.indicus": 1.8,
			"Merinoorsimilarbreed": 1.43,
			"Meatsheep(e.g.PollDorset)": 1.43
		},
		"C(P,6)": {
			"British(e.g.Angus,Hereford)": 2.42,
			"European(e.g.Simmental)": 2.42,
			"Bosindicus(e.g.Brahman)": 2.42,
			"BritishxEuropean": 2.42,
			"BritishxB.indicus": 2.42,
			"Merinoorsimilarbreed": 3.38,
			"Meatsheep(e.g.PollDorset)": 3.38
		},
		"C(P,7)": {
			"British(e.g.Angus,Hereford)": 1.16,
			"European(e.g.Simmental)": 1.16,
			"Bosindicus(e.g.Brahman)": 1.16,
			"BritishxEuropean": 1.16,
			"BritishxB.indicus": 1.16,
			"Merinoorsimilarbreed": 0.91,
			"Meatsheep(e.g.PollDorset)": 0.91
		},
		"C(P,8)": {
			"British(e.g.Angus,Hereford)": 4.11,
			"European(e.g.Simmental)": 4.11,
			"Bosindicus(e.g.Brahman)": 4.11,
			"BritishxEuropean": 4.11,
			"BritishxB.indicus": 4.11,
			"Merinoorsimilarbreed": 4.33,
			"Meatsheep(e.g.PollDorset)": 4.33
		},
		"C(P,9)": {
			"British(e.g.Angus,Hereford)": 343.5,
			"European(e.g.Simmental)": 343.5,
			"Bosindicus(e.g.Brahman)": 343.5,
			"BritishxEuropean": 343.5,
			"BritishxB.indicus": 343.5,
			"Merinoorsimilarbreed": 4.37,
			"Meatsheep(e.g.PollDorset)": 4.37
		},
		"C(P,10)": {
			"British(e.g.Angus,Hereford)": 0.0164,
			"European(e.g.Simmental)": 0.0164,
			"Bosindicus(e.g.Brahman)": 0.0164,
			"BritishxEuropean": 0.0164,
			"BritishxB.indicus": 0.0164,
			"Merinoorsimilarbreed": 0.965,
			"Meatsheep(e.g.PollDorset)": 0.965
		},
		"C(P,14,1)": {
			"British(e.g.Angus,Hereford)": 1,
			"European(e.g.Simmental)": 1,
			"Bosindicus(e.g.Brahman)": 1,
			"BritishxEuropean": 1,
			"BritishxB.indicus": 1,
			"Merinoorsimilarbreed": 1.5,
			"Meatsheep(e.g.PollDorset)": 1.5
		},
		"C(P,14,2)": {
			"British(e.g.Angus,Hereford)": null,
			"European(e.g.Simmental)": null,
			"Bosindicus(e.g.Brahman)": null,
			"BritishxEuropean": null,
			"BritishxB.indicus": null,
			"Merinoorsimilarbreed": 1.75,
			"Meatsheep(e.g.PollDorset)": 1.75
		},
		"C(L,0,1)": {
			"British(e.g.Angus,Hereford)": 0.375,
			"European(e.g.Simmental)": 0.375,
			"Bosindicus(e.g.Brahman)": 0.375,
			"BritishxEuropean": 0.375,
			"BritishxB.indicus": 0.375,
			"Merinoorsimilarbreed": 0.389,
			"Meatsheep(e.g.PollDorset)": 0.486
		},
		"C(L,0,2)": {
			"British(e.g.Angus,Hereford)": null,
			"European(e.g.Simmental)": null,
			"Bosindicus(e.g.Brahman)": null,
			"BritishxEuropean": null,
			"BritishxB.indicus": null,
			"Merinoorsimilarbreed": 0.622,
			"Meatsheep(e.g.PollDorset)": 0.778
		},
		"C(L,1)": {
			"British(e.g.Angus,Hereford)": 4,
			"European(e.g.Simmental)": 4,
			"Bosindicus(e.g.Brahman)": 4,
			"BritishxEuropean": 4,
			"BritishxB.indicus": 4,
			"Merinoorsimilarbreed": 2,
			"Meatsheep(e.g.PollDorset)": 2
		},
		"C(L,2)": {
			"British(e.g.Angus,Hereford)": 30,
			"European(e.g.Simmental)": 30,
			"Bosindicus(e.g.Brahman)": 30,
			"BritishxEuropean": 30,
			"BritishxB.indicus": 30,
			"Merinoorsimilarbreed": 22,
			"Meatsheep(e.g.PollDorset)": 22
		},
		"C(L,3)": {
			"British(e.g.Angus,Hereford)": 0.6,
			"European(e.g.Simmental)": 0.6,
			"Bosindicus(e.g.Brahman)": 0.6,
			"BritishxEuropean": 0.6,
			"BritishxB.indicus": 0.6,
			"Merinoorsimilarbreed": 1,
			"Meatsheep(e.g.PollDorset)": 1
		},
		"C(L,6)": {
			"British(e.g.Angus,Hereford)": 3.1,
			"European(e.g.Simmental)": 3.1,
			"Bosindicus(e.g.Brahman)": 3.1,
			"BritishxEuropean": 3.1,
			"BritishxB.indicus": 3.1,
			"Merinoorsimilarbreed": 4.7,
			"Meatsheep(e.g.PollDorset)": 4.7
		},
		"C(L,12)": {
			"British(e.g.Angus,Hereford)": 0.42,
			"European(e.g.Simmental)": 0.42,
			"Bosindicus(e.g.Brahman)": 0.42,
			"BritishxEuropean": 0.42,
			"BritishxB.indicus": 0.42,
			"Merinoorsimilarbreed": 0.3,
			"Meatsheep(e.g.PollDorset)": 0.3
		},
		"C(L,13)": {
			"British(e.g.Angus,Hereford)": 0.58,
			"European(e.g.Simmental)": 0.58,
			"Bosindicus(e.g.Brahman)": 0.58,
			"BritishxEuropean": 0.58,
			"BritishxB.indicus": 0.58,
			"Merinoorsimilarbreed": 0.41,
			"Meatsheep(e.g.PollDorset)": 0.41
		},
		"C(L,14)": {
			"British(e.g.Angus,Hereford)": 0.036,
			"European(e.g.Simmental)": 0.036,
			"Bosindicus(e.g.Brahman)": 0.036,
			"BritishxEuropean": 0.036,
			"BritishxB.indicus": 0.036,
			"Merinoorsimilarbreed": 0.071,
			"Meatsheep(e.g.PollDorset)": 0.071
		},
		"C(L,21)": {
			"British(e.g.Angus,Hereford)": 0.004,
			"European(e.g.Simmental)": 0.004,
			"Bosindicus(e.g.Brahman)": 0.004,
			"BritishxEuropean": 0.004,
			"BritishxB.indicus": 0.004,
			"Merinoorsimilarbreed": 0.008,
			"Meatsheep(e.g.PollDorset)": 0.008
		},
		"C(L,22)": {
			"British(e.g.Angus,Hereford)": 0.006,
			"European(e.g.Simmental)": 0.006,
			"Bosindicus(e.g.Brahman)": 0.006,
			"BritishxEuropean": 0.006,
			"BritishxB.indicus": 0.006,
			"Merinoorsimilarbreed": 0.012,
			"Meatsheep(e.g.PollDorset)": 0.012
		},
		"C(W,A)": {
			"British(e.g.Angus,Hereford)": 0,
			"European(e.g.Simmental)": 0,
			"Bosindicus(e.g.Brahman)": 0,
			"BritishxEuropean": 0,
			"BritishxB.indicus": 0,
			"Merinoorsimilarbreed": 0.043,
			"Meatsheep(e.g.PollDorset)": 0.03
		},
		"C(W,6)": {
			"British(e.g.Angus,Hereford)": 0,
			"European(e.g.Simmental)": 0,
			"Bosindicus(e.g.Brahman)": 0,
			"BritishxEuropean": 0,
			"BritishxB.indicus": 0,
			"Merinoorsimilarbreed": 0.03,
			"Meatsheep(e.g.PollDorset)": 0.11
		},
		"C(W,B)": {
			"British(e.g.Angus,Hereford)": 0,
			"European(e.g.Simmental)": 0,
			"Bosindicus(e.g.Brahman)": 0,
			"BritishxEuropean": 0,
			"BritishxB.indicus": 0,
			"Merinoorsimilarbreed": 0.137,
			"Meatsheep(e.g.PollDorset)": 0.137
		},
		"EVG(max)": {
			"British(e.g.Angus,Hereford)": 27,
			"European(e.g.Simmental)": 23.2,
			"Bosindicus(e.g.Brahman)": 27,
			"BritishxEuropean": 25.1,
			"BritishxB.indicus": 27,
			"Merinoorsimilarbreed": 27,
			"Meatsheep(e.g.PollDorset)": 27
		},
		"EVG(range)": {
			"British(e.g.Angus,Hereford)": 20.3,
			"European(e.g.Simmental)": 16.5,
			"Bosindicus(e.g.Brahman)": 20.3,
			"BritishxEuropean": 18.4,
			"BritishxB.indicus": 20.3,
			"Merinoorsimilarbreed": 20.3,
			"Meatsheep(e.g.PollDorset)": 20.3
		},
		"SRW": {
			"British(e.g.Angus,Hereford)": 500,
			"European(e.g.Simmental)": 650,
			"Bosindicus(e.g.Brahman)": 550,
			"BritishxEuropean": 575,
			"BritishxB.indicus": 550,
			"Merinoorsimilarbreed": 50,
			"Meatsheep(e.g.PollDorset)": 65
		}
	}
}
